module.exports = __webpack_public_path__ + "img/good.3243077c.svg";